import React, {forwardRef, memo} from 'react';
import {Flex, Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import cx from 'classnames';
import {HomepageItemData} from '../../api';
import {TileIcon, TileIconType} from './enum';
import {Counter} from '../Counter';
import {useEntityHandlers} from './hooks/useEntityHandlers';
import {ignoreDragClassName} from '../../constants';
import styles from './styles.module.scss';

type Props = HomepageItemData;

export const Tile = memo(
    forwardRef<HTMLDivElement, Props>((props: Props, ref) => {
        const {title, exec, type, countIssues, ename, etype, mymenu} = props;
        const icon = TileIcon[type];
        const count = Number(countIssues) || 0;
        const isDisabled = props.disabled === '1';

        const {onCounterClick, openFormNewRecord, openFormSearch, openEntity, deleteTile} =
            useEntityHandlers({exec, title, mymenu, type, ename, etype, isDisabled});

        return (
            <div
                className={cx(styles.component, {[styles.disabled]: isDisabled})}
                key={exec}
                ref={ref}
                onClick={openEntity}
            >
                <div
                    className={cx(styles.iconWrap, {
                        [styles.formIcon]: type === TileIconType.F,
                        [styles.procIcon]:
                            type === TileIconType.P ||
                            type === TileIconType.G ||
                            type === TileIconType.E,
                        [styles.repIcon]: type === TileIconType.R,
                        [styles.menuIcon]: type === TileIconType.H,
                        [styles.biIcon]: type === TileIconType.O,
                        [styles.wizardIcon]: type === TileIconType.B,
                        [styles.dashboard]: type === TileIconType.D
                    })}
                >
                    <Icon icon={icon as PriorityIcon} componentClasses={styles.mainIcon}></Icon>
                </div>

                <div className={styles.titleWrap}>
                    <Text componentClasses={styles.title} skin="paragraph-1">
                        {title}
                    </Text>
                </div>

                <div className={styles.formFooter}>
                    <Icon
                        icon={PriorityIcon.delete}
                        iconColor="primary-700"
                        onClick={deleteTile}
                        componentClasses={cx(ignoreDragClassName, styles.deleteIcon)}
                    />

                    {type === TileIconType.F ? (
                        <Flex inline className={styles.footerIcons}>
                            <Icon
                                componentClasses={cx(ignoreDragClassName, styles.icon)}
                                iconColor="primary-700"
                                onClick={openFormSearch}
                                icon={PriorityIcon.searchThin}
                            />
                            <Icon
                                componentClasses={cx(ignoreDragClassName, styles.icon)}
                                iconColor="primary-700"
                                onClick={openFormNewRecord}
                                icon={PriorityIcon.newAdd}
                            />
                        </Flex>
                    ) : null}
                </div>

                {count ? (
                    <Counter
                        number={count}
                        onClick={onCounterClick}
                        componentClasses={cx(styles.counter, ignoreDragClassName)}
                    />
                ) : null}
            </div>
        );
    })
);
